const homeSplashCarouselMobileBreakpoint = 992;

const initializeSplashCarouselNavHover = (options) => {
  const { $homeSplashCarousel } = options;

  const callbackFn = (options) => {
    
    if ($(window).width() < homeSplashCarouselMobileBreakpoint) return;
    
    const { newIndex, type } = options;
    const currentSlideIndex = $homeSplashCarousel?.slick('slickCurrentSlide');
    const updatedIndex = currentSlideIndex + newIndex;
    const peakClass = updatedIndex > currentSlideIndex ? 'peak-next' : 'peak-prev';
    const shiftClass = updatedIndex > currentSlideIndex ? 'shift-left' : 'shift-right';

    const $currentEl = $(`.home-splash-carousel__slide[data-slick-index=${currentSlideIndex}]`);
    const $subsequentEl = $(`.home-splash-carousel__slide[data-slick-index=${updatedIndex}]`);

    if (type === 'mouseenter') {
      $currentEl.addClass(shiftClass);
      $subsequentEl.addClass(peakClass);
    } else {
      $currentEl.removeClass(shiftClass);
      $subsequentEl.removeClass(peakClass);
    }
  };

  $('.slick-arrow.arrow-prev')
    .on('mouseenter', function() { callbackFn({ newIndex: -1, type: 'mouseenter' }); })
    .on('mouseleave', function() { callbackFn({ newIndex: -1, type: 'mouseleave' }); });

  $('.slick-arrow.arrow-next')
    .on('mouseenter', function() { callbackFn({ newIndex: 1, type: 'mouseenter' }); })
    .on('mouseleave', function() { callbackFn({ newIndex: 1, type: 'mouseleave' }); });

  $homeSplashCarousel.on('beforeChange', function() {
    // Remove all peak and shift classes on press
    const $el = $homeSplashCarousel.find(`.home-splash-carousel__slide`);
    $el.removeClass('peak-prev peak-next shift-left shift-right');
  });
  
}

const initializeSplashCarouselPauseOnHover = ({ $homeSplashCarousel }) => {
  $('#homeSplashCarouselInfo')
    .on('mouseenter', function() {
      if ($(window).width() < homeSplashCarouselMobileBreakpoint) return;
      $('.home-splash-carousel__nav-item-progress-bar').addClass('pause');
    })
    .on('mouseleave', function() {
      if ($(window).width() < homeSplashCarouselMobileBreakpoint) return;
      $('.home-splash-carousel__nav-item-progress-bar').removeClass('pause');
    })
}

const toggleSlideContent = ({ index, type }) => {
  const $currentEl = $(`#homeSplashCarouselInfo .home-splash-carousel__info-content-item[data-index="${index}"]`);

  if (type === 'show') {
    $currentEl.addClass('pseudo-show');
    setTimeout(() => { $currentEl.addClass('show') }, 0);
  } else {
    $currentEl.removeClass('show');
    setTimeout(() => { $currentEl.removeClass('pseudo-show') }, 0);
  }

}

const initializeSplashCarousel = () => {
  const classNavItem = 'home-splash-carousel__nav-item';

  const $homeSplashCarouselContainer = $('.home-splash-carousel');
  const $homeSplashCarousel = $homeSplashCarouselContainer
    .find('.home-splash-carousel__slides');

  const duration = $homeSplashCarouselContainer.data('duration') || 3000;
  let bgThemes = [];
  $homeSplashCarousel.find('.home-splash-carousel__slide')
    .each(function() { bgThemes.push($(this).data('theme')) });

  // Set up animation speeds
  $(`.${classNavItem} .${classNavItem}-progress-bar`)
    .css({ 'animation-duration': `${duration}ms` });

  // Set main nav arrow color
  $homeSplashCarouselContainer.addClass(bgThemes[0]);

  $homeSplashCarousel.not('.slick-initialized').slick({
    mobileFirst: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: false,
    prevArrow: '<div class="arrow-prev d-flex align-items-center"><svg class="d-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M59.74 115.2a2.59 2.59 0 0 1-3.66 0L.76 59.8a2.58 2.58 0 0 1 0-3.65L56.08.76a2.58 2.58 0 0 1 3.66 3.65L6.24 58l53.5 53.56a2.59 2.59 0 0 1 0 3.66z"></path></svg></div>',
    nextArrow: '<div class="arrow-next d-flex align-items-center justify-content-end"><svg class="d-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M.76.76a2.58 2.58 0 0 1 3.65 0l55.33 55.4a2.58 2.58 0 0 1 0 3.65L4.4 115.2a2.58 2.58 0 1 1-3.65-3.65L54.26 58 .76 4.42a2.59 2.59 0 0 1 0-3.66z"></path></svg></div>',
    responsive: []
  });

  // Start animations
  $(`.${classNavItem}[data-index="0"]`).addClass(`is-active`);
  toggleSlideContent({ index: 0, type: 'show' });

  // Autoplay using progress bar CSS animation duration
  $('.home-splash-carousel__nav-item-progress').on('animationend', function() {
    const currentSlideIndex = $homeSplashCarousel?.slick('slickCurrentSlide');
    $homeSplashCarousel?.slick('slickGoTo', currentSlideIndex + 1);
  });

  $homeSplashCarousel.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    toggleSlideContent({ index: currentSlide, type: 'hide' });

    // Hide current progress bar animation
    $(`.${classNavItem}`).removeClass(`is-active`);

    // Start progress bar animation of nextslide
    $(`.${classNavItem}[data-index="${nextSlide}"]`).addClass(`is-active`);
  });

  $homeSplashCarousel.on('afterChange', function(event, slick, currentSlide){
    toggleSlideContent({ index: currentSlide, type: 'show' });

    try {
      // start and pause videos if any
      const currentVideo = $(`.home-splash-carousel__slide[data-slick-index="${currentSlide}"] > video`);
      $(`.home-splash-carousel__slide > video`).each(function() {
        const video = $(this).get(0);
        const isPlaying = video.currentTime > 0 && !video.paused && !video.ended && video.readyState > video.HAVE_CURRENT_DATA;
        if (isPlaying) video.pause();
      });

      if ((currentVideo.length > 0 && window.innerWidth >= 992) && currentVideo.get(0).paused)currentVideo.get(0).play();
    } catch (e) {
      if (typeof Sentry != 'undefined') Sentry.captureException(e);
    }

    // Update arrows to new color
    $homeSplashCarouselContainer.removeClass('light dark');
    $homeSplashCarouselContainer.addClass(bgThemes[currentSlide]);
  });

  // Nav arrows click events
  if ($(`.${classNavItem}`).length > 3) {
    $homeSplashCarouselContainer.find('#prev').on('click', function() {
      const currentSlideIndex = $homeSplashCarousel?.slick('slickCurrentSlide');
      $homeSplashCarousel?.slick('slickGoTo', currentSlideIndex - 1);
    });
    $homeSplashCarouselContainer.find('#next').on('click', function() {
      const currentSlideIndex = $homeSplashCarousel?.slick('slickCurrentSlide');
      $homeSplashCarousel?.slick('slickGoTo', currentSlideIndex + 1);
    });
  } else {
    $homeSplashCarouselContainer.find('#prev').hide();
    $homeSplashCarouselContainer.find('#next').hide();
  }

  // Jump to slide
  $(`.${classNavItem}`).on('click', function() {
    const currentSlideIndex = $homeSplashCarousel?.slick('slickCurrentSlide');
    if (currentSlideIndex === $(this).data('index')) return;
    $homeSplashCarousel?.slick('slickGoTo', $(this).data('index'));
  });

  initializeSplashCarouselNavHover({ $homeSplashCarousel });
  initializeSplashCarouselPauseOnHover({ $homeSplashCarousel });
};

whenAvailable('$', function() {
  $(function(){
      whenAvailable('slick',function() {
          $('.slick-revolving','.slick-revolving-sm').on('init', function(event, slick){
              whenAvailable('lazyload', function(){
                  setTimeout(function() {
                      initLazyload();
                  }, 500);
              });
          });

          function initSlickRevolving() {
              let slick_intialized = $('.slick-revolving').hasClass('slick-initialized');
              let slick_intialized_sm = $('.slick-revolving-sm').hasClass('slick-initialized');


              if ( !slick_intialized && window.innerWidth >= 768 ) {
                  $('.slick-revolving')?.slick({
                      mobileFirst: true,
                      infinite: true,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      centerMode: true,
                      centerPadding: 'calc(100vw / 12)',
                      dots: true,
                      prevArrow: '<div class="arrow-prev d-md-flex"><svg class="d-none d-md-block ms-auto me-3 me-xl-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M59.74 115.2a2.59 2.59 0 0 1-3.66 0L.76 59.8a2.58 2.58 0 0 1 0-3.65L56.08.76a2.58 2.58 0 0 1 3.66 3.65L6.24 58l53.5 53.56a2.59 2.59 0 0 1 0 3.66z"></path></svg></div>',
                      nextArrow: '<div class="arrow-next d-md-flex"><svg class="d-none d-md-block ms-3 ms-xl-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M.76.76a2.58 2.58 0 0 1 3.65 0l55.33 55.4a2.58 2.58 0 0 1 0 3.65L4.4 115.2a2.58 2.58 0 1 1-3.65-3.65L54.26 58 .76 4.42a2.59 2.59 0 0 1 0-3.66z"></path></svg></div>',
                      responsive: [
                          {
                              breakpoint: 1200,
                              settings: {
                                  infinite: true,
                                  centerMode: true,
                                  centerPadding: 'calc(100vw / 6)'
                              }
                          }
                      ]
                  });
                  $('.slick-revolving-mweb')?.slick({
                      mobileFirst: true,
                      infinite: true,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      centerMode: true,
                      centerPadding: 'calc(100vw / 12)',
                      dots: true,
                      prevArrow: '<div class="arrow-prev d-md-flex"><svg class="d-md-block ms-auto me-3 me-xl-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M59.74 115.2a2.59 2.59 0 0 1-3.66 0L.76 59.8a2.58 2.58 0 0 1 0-3.65L56.08.76a2.58 2.58 0 0 1 3.66 3.65L6.24 58l53.5 53.56a2.59 2.59 0 0 1 0 3.66z"></path></svg></div>',
                      nextArrow: '<div class="arrow-next d-md-flex"><svg class="d-md-block ms-3 ms-xl-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M.76.76a2.58 2.58 0 0 1 3.65 0l55.33 55.4a2.58 2.58 0 0 1 0 3.65L4.4 115.2a2.58 2.58 0 1 1-3.65-3.65L54.26 58 .76 4.42a2.59 2.59 0 0 1 0-3.66z"></path></svg></div>',
                      responsive: [
                          {
                              breakpoint: 1200,
                              settings: {
                                  infinite: true,
                                  centerMode: true,
                                  centerPadding: 'calc(100vw / 6)'
                              }
                          }
                      ]
                  });
              } else if ( slick_intialized && window.innerWidth < 768 ) {
                  $('.slick-revolving')?.slick('unslick');
              }
              if ( !slick_intialized_sm && window.innerWidth < 768) {
                  $('.slick-revolving-sm')?.slick({
                      mobileFirst: true,
                      infinite: true,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      centerMode: true,
                      centerPadding: 'calc(100vw / 12)',
                      dots: true,
                      prevArrow: '<div class="arrow-prev d-md-flex"><svg class="d-md-block ms-auto me-3 me-xl-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M59.74 115.2a2.59 2.59 0 0 1-3.66 0L.76 59.8a2.58 2.58 0 0 1 0-3.65L56.08.76a2.58 2.58 0 0 1 3.66 3.65L6.24 58l53.5 53.56a2.59 2.59 0 0 1 0 3.66z"></path></svg></div>',
                      nextArrow: '<div class="arrow-next d-md-flex"><svg class="d-md-block ms-3 ms-xl-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M.76.76a2.58 2.58 0 0 1 3.65 0l55.33 55.4a2.58 2.58 0 0 1 0 3.65L4.4 115.2a2.58 2.58 0 1 1-3.65-3.65L54.26 58 .76 4.42a2.59 2.59 0 0 1 0-3.66z"></path></svg></div>',
                      responsive: [
                          {
                              breakpoint: 1200,
                              settings: {
                                  infinite: true,
                                  centerMode: true,
                                  centerPadding: 'calc(100vw / 6)'
                              }
                          }
                      ]
                  });
              } else if ( slick_intialized_sm && window.innerWidth >= 768 ) {
                  $('.slick-revolving-sm')?.slick('unslick');
              }

          }
          initSlickRevolving();
          window.onresize = () => { initSlickRevolving() }

          initializeSplashCarousel();
      });
      // Accordion for warranty section
      $('#accordionHomePage .collapse').each((i, e) =>
        $(e).on('hidden.bs.collapse', () => {
            // check if an accordion item is expanded
            let isExpanded = false;
            let classActive = "homepage-show-1"
            $('#accordionHomePage [aria-expanded]').each((i, element) => {
                if ($(element).attr("aria-expanded") === 'true') {
                    isExpanded = true;
                }

                if (!element.classList.contains('collapsed')) classActive = element.id
            });

            $(".homepage-show").addClass("opacity-0");
            $(`.${classActive}`).removeClass("opacity-0");

            // show the first accordion item
            /*if (!isExpanded) {
                $('#homepage-show-1').click();
            }*/
        })
      );
  });

  document.addEventListener('DOMContentLoaded', function() {
      //eligibleCountriesForFreeTrial and eligibleStoreCodeBaseOnCountries are a pair, need to match both
    const eligibleCountriesForFreeTrial = ['NL', 'PL'];
    const eligibleStoreCodeBaseOnCountries = ['XX'];

    const eligibleStoreCode = ['XX'];

    const currentCountry = getCookie('_geo_country_code');
    const store_code = $('body').data('store-code');

    if ((eligibleCountriesForFreeTrial.includes(currentCountry) && eligibleStoreCodeBaseOnCountries.includes(store_code)) || eligibleStoreCode.includes(store_code)){
        $('.carousel-free-trial-button').show();
        $('.free-trial-banner').show();
    } else {

        $('.carousel-free-trial-button').remove();
        $('.free-trial-banner').remove();
        $('.free-trial-banner-content').remove();
    }
    // Select all buttons inside the `.home-splash-carousel__nav-content` container
    const navItems = document.querySelectorAll('.home-splash-carousel__nav-item.item');
    const navItemsContent = document.querySelectorAll('.home-splash-carousel__info-content-item.item');
    const navItemsSlide = document.querySelectorAll('.home-splash-carousel__slide.item');

    navItems.forEach((item, index) => {
      // Set data-index attribute to the current index
      item.setAttribute('data-index', index);
    });
    navItemsContent.forEach((item, index) => {
      // Set data-index attribute to the current index
      item.setAttribute('data-index', index);
    });
    navItemsSlide.forEach((item, index) => {
      // Set data-index attribute to the current index
      item.setAttribute('data-index', index);
    });
  });
});
